import React from "react"
import { useTranslation } from "react-i18next"
import { Container, Row, Col } from "reactstrap"
import FeatherIcon from "feather-icons-react"

const WhyNettaSection = () => {
    const { t } = useTranslation()

    const features = [
        { key: "integrated", icon: "layers" },
        { key: "turkish", icon: "headphones" },
        { key: "flexible", icon: "cloud" },
        { key: "compliant", icon: "shield" },
        { key: "customizable", icon: "settings" },
        { key: "scalable", icon: "trending-up" }
    ]

    return (
        <section className="section bg-light">
            <Container>
                {/* Section Title */}
                <Row className="justify-content-center">
                    <Col xs={12} className="text-center">
                        <div className="section-title mb-4 pb-2">
                            <h4 className="title mb-4">{t("why.title")}</h4>
                            <p className="text-muted para-desc mx-auto mb-0">
                                {t("why.subtitle")}
                            </p>
                        </div>
                    </Col>
                </Row>

                {/* Features Grid */}
                <Row>
                    {features.map((feature, key) => (
                        <Col lg={4} md={6} className="mt-4 pt-2" key={key}>
                            <div className="d-flex">
                                <div className="icons text-primary text-center mx-auto">
                                    <FeatherIcon
                                        icon={feature.icon}
                                        className="fea icon-ex-md"
                                    />
                                </div>
                                <div className="flex-1 ms-3">
                                    <h5>{t(`why.features.${feature.key}.title`)}</h5>
                                    <p className="text-muted mb-0">
                                        {t(`why.features.${feature.key}.description`)}
                                    </p>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    )
}

export default WhyNettaSection
